import { create } from 'zustand';

export interface SiteListFilterObject {
	lastActivityDate: [Date | null, Date | null];
	siteType: string;
	contractorType: string;
	convertStatus: boolean;
	source: string; // Site Specialist filter
	location: {
		lat: number | null;
		lng: number | null;
		name: string;
	};
	site_current_status_c?: string;
	createdAt: [Date | null, Date | null];
	date_of_next_visit: [Date | null, Date | null]; // Add this line
	solvent_used_c?: string; // Add this line for competition sites
}

export interface SiteListFilterStore {
	siteListFilter: SiteListFilterObject;
	updateFilter: (filterObject: SiteListFilterObject) => void;
	resetFilter: () => void;
}

export const siteListFilterInitialValues: SiteListFilterObject = {
	lastActivityDate: [null, null],
	createdAt: [null, null],
	siteType: '',
	contractorType: '',
	convertStatus: false,
	source: '', // Default empty source filter
	location: {
		lat: null,
		lng: null,
		name: '',
	},
	site_current_status_c: '',
	date_of_next_visit: [null, null], // Add this line
	solvent_used_c: '', // Add this line
};

const initialState: { siteListFilter: SiteListFilterObject } = {
	siteListFilter: siteListFilterInitialValues,
};

export const useSiteListFilterStore = create<SiteListFilterStore>((set) => ({
	...initialState,
	updateFilter: (filterObject: SiteListFilterObject): void =>
		set((state) => ({
			siteListFilter: { ...state.siteListFilter, ...filterObject },
		})),
	resetFilter: (): void =>
		set(() => ({
			...initialState,
		})),
}));
